<script lang="ts" context="module">
	import Footer from "./Footer.svelte";
	import PageBorder from "./PageBorder.svelte";

	type Border = {
		color: "teal" | "blue" | "gray" | "purple" | "green";
		opacity: 50 | 100;
	};
</script>

<script lang="ts">
	export let border: Border | undefined = undefined;
	export let hideFooter: boolean = false;
	export let width: "1000px" | "1200px" | "full" = "1200px";
</script>

{#if border}
	<PageBorder color={border.color} opacity={border.opacity} />
{:else}
	<slot name="border" />
{/if}

<div class="flex flex-col justify-between pt-8" style="min-height: calc(100vh - var(--full-toolbar-height, 0px) - 10px);">
	<div class="mx-auto my-0 box-border w-full px-[20px]" class:max-w-[1040px]={width === "1000px"} class:max-w-[1240px]={width === "1200px"}>
		<slot />
	</div>

	{#if !hideFooter}
		<Footer />
	{/if}
</div>
